import {Action} from '@ngrx/store';
import {PageSettings} from '../../model/page-settings.model';


export const UPDATE_OFFERS = '[MAINTENANCE_OFFER] UPDATE_OFFERS';
export const UPDATED_OFFERS = '[MAINTENANCE_OFFER] UPDATED_OFFERS';

export const UPDATE_PAGE_SETTINGS = '[MAINTENANCE_OFFER] UPDATE_PAGE_SETTINGS';
export const UPDATE_PAGE_SETTINGS_PAGE = '[MAINTENANCE_OFFER] UPDATE_PAGE_SETTINGS_PAGE';

export const UPDATE_SEARCH_PARAMS = '[MAINTENANCE_OFFER] UPDATE_SEARCH_PARAMS';
export const DELETE_SEARCH_PARAMS = '[MAINTENANCE_OFFER] DELETE_SEARCH_PARAMS';


/**
 * UPDATE ACTIONS
 */
export class UpdateOffersAction implements Action {

  readonly type = UPDATE_OFFERS;
}

export class UpdatePageSettings implements Action {
  readonly type = UPDATE_PAGE_SETTINGS;

  constructor(public payload: PageSettings) {
  }
}

export class UpdatePageSettingsPage implements Action {
  readonly type = UPDATE_PAGE_SETTINGS_PAGE;

  constructor(public page: number) {
  }
}

export class UpdateSearchParamsAction implements Action {
  readonly type = UPDATE_SEARCH_PARAMS;

  constructor(public payload: OfferMaintenanceSearchParams) {
  }
}

export class DeleteSearchParamsAction implements Action {
  readonly type = DELETE_SEARCH_PARAMS;
}

/**
 * UPDATED ACTIONS
 */

export class UpdatedOffersAction implements Action {
  readonly type = UPDATED_OFFERS;

  constructor(public payload: OfferMaintenanceDto) {
  }
}


export type MaintenanceOfferAction =
    UpdateOffersAction
    | UpdatedOffersAction
    | UpdatePageSettings
    | UpdatePageSettingsPage
    | UpdateSearchParamsAction
    | DeleteSearchParamsAction;
